import { Option } from '@/components/inputs/AutocompleteInput';
import { SelectInputOption } from '@/components/inputs/SelectInput';
import { useMemo } from 'react';
import {
  useAutocompleteSearch,
  useStableOptions,
} from '@/hooks/useAutocompleteSearch';
import { useGetOfficesQuery } from '../../Geography/Offices/services/offices.service';

interface UseOfficesOptionsProps {
  search?: string;
}

const useOfficesOptions = ({ search }: UseOfficesOptionsProps = {}) => {
  const { debouncedSearch, isDebouncePending } = useAutocompleteSearch(
    search,
    0
  );

  const { data: offices, isFetching: isOfficesFetching } = useGetOfficesQuery({
    filters: debouncedSearch ? { name: debouncedSearch } : undefined,
    paginated: {
      page: 1,
      pageSize: 1000,
    },
  });

  const resolvedOfficeOptions = useMemo<Option[]>(
    () =>
      (offices?.items ?? []).map((office) => ({
        label: `${office.name} - ${office.city?.name || 'Sin ciudad'}`,
        data: office.id,
      })),
    [offices?.items]
  );

  const officeOptions = useStableOptions(resolvedOfficeOptions, {
    isPending: isOfficesFetching || isDebouncePending,
    enabled: true,
  });

  const officeSelectOptions = useMemo<SelectInputOption[]>(
    () =>
      officeOptions.map((option) => ({
        label: option.label,
        value: option.data,
      })),
    [officeOptions]
  );

  return {
    officeOptions,
    officeSelectOptions,
    isOfficesLoading: isOfficesFetching,
  };
};

export default useOfficesOptions; 